import delegate from 'delegate'

/**
 * Prevents image context menu from opening
 * to making downloading more difficult
 */

export default function () {
  delegate('img', 'contextmenu', e => {
    e.preventDefault()
    return false
  }, false)
}